import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const ThesisViewer = () => {
  const [isLoading, setIsLoading] = useState(true);
  const pdfUrl = '/assets/documents/XR-Thesis.pdf';

  return (
    <div className="min-h-screen bg-gray-900 text-white">
      {/* Header */}
      <div className="bg-gray-800 border-b border-gray-700 px-4 py-3">
        <div className="max-w-7xl mx-auto flex items-center justify-between">
          <div className="flex items-center gap-4">
            <Link
              to="/xr-thesis"
              className="flex items-center gap-2 text-gray-400 hover:text-white transition-colors"
            >
              <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
              </svg>
              <span>Back to Project</span>
            </Link>
            <div className="h-6 w-px bg-gray-700"></div>
            <div>
              <h1 className="text-lg font-semibold">Honours Thesis</h1>
              <p className="text-xs text-gray-400">Understanding Virtual to Real Content in Extended Reality</p>
            </div>
          </div>
          
          <div className="flex items-center gap-3">
            <a
              href={pdfUrl}
              download="Arunav_Saha_XR_Thesis.pdf"
              className="flex items-center gap-2 px-4 py-2 bg-gray-700 hover:bg-gray-600 rounded-lg transition-colors text-sm"
            >
              <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
              </svg>
              Download
            </a>
            <a
              href={pdfUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 px-4 py-2 bg-purple-600 hover:bg-purple-500 rounded-lg transition-colors text-sm"
            >
              <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
              </svg>
              Open in New Tab
            </a>
          </div>
        </div>
      </div>

      {/* PDF Viewer */}
      <div className="relative" style={{ height: 'calc(100vh - 60px)' }}>
        {isLoading && (
          <div className="absolute inset-0 flex items-center justify-center bg-gray-900">
            <div className="text-center">
              <div className="w-12 h-12 border-4 border-gray-700 border-t-purple-500 rounded-full animate-spin mx-auto mb-4"></div>
              <p className="text-gray-400">Loading Thesis...</p>
            </div>
          </div>
        )}
        <iframe
          src={pdfUrl}
          className="w-full h-full"
          title="Honours Thesis - Understanding Virtual to Real Content in Extended Reality"
          onLoad={() => setIsLoading(false)}
        />
      </div>
    </div>
  );
};

export default ThesisViewer;
